import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

// INTERFACES
import { Observable } from 'rxjs';

import { ICompany } from './../../../client/interfaces/client-company.interface';

// SERVICES
import { ClientCompanyApiService } from './../../../shared/services/api/client/client-company-api.service';

@Component({
  selector: 'lum-company-autocomplete',
  templateUrl: './company-autocomplete.component.html',
  styleUrls: ['./company-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyAutocompleteComponent),
      multi: true,
    },
  ],
})
export class CompanyAutocompleteComponent implements OnInit {
  @Input()
  placeholder :string = 'Search for a company';

  selectedItem :ICompany | null = null;

  constructor(private clientCompanyApiService :ClientCompanyApiService) {}

  ngOnInit() :void {
    this.clientCompanyApiService.get({});
  }

  onChange = (value :ICompany) => {};
  onTouched = () => {};

  // Called when value is written from form control
  writeValue(value :ICompany) :void {
    this.selectedItem = value;
  }

  // Registers a function to propagate changes to the form
  registerOnChange(fn :any) :void {
    this.onChange = fn;
  }

  // Registers a function to call when the control is touched
  registerOnTouched(fn :any) :void {
    this.onTouched = fn;
  }

  onSelectItem(selectedItem :ICompany) :void {
    if (selectedItem.id === this.selectedItem?.id) {
      return;
    }

    this.onChange(selectedItem);
  }

  onSearch(event :InputEvent) :void {
    const business_name = (event.target as HTMLInputElement)?.value || '';

    this.loadCompanies({
      params: {
        business_name,
      },
    });
  }

  displayFn(channel :ICompany) :string {
    return channel?.business_name || '';
  }

  loadCompanies({ params = {} }) :void {
    this.clientCompanyApiService.get({
      relations: 'clientType.warehouseGroup',
      ...params,
    });
  }

  get companies$() :Observable<ICompany[]> {
    return this.clientCompanyApiService.companies$;
  }

  get loading$() :Observable<boolean> {
    return this.clientCompanyApiService.loading$;
  }
}
